<template>
  <div>
    <banner-component title="Franck Besson, développeur full stack et fondateur de Citron Digital" :lead="lead" :breadcrumbs="breadcrumbs" ruled>
      <router-link class="btn btn--primary" to="/contact">Me contacter</router-link>
      <router-link class="btn btn--ghost" to="/gestionnaire-citron">Découvrir le Gestionnaire Citron</router-link>
    </banner-component>

    <section class="band" aria-labelledby="experience-title">
      <div class="container">
        <h2 id="experience-title">Expériences professionnelles</h2>
        <experiences-component/>
      </div>
    </section>

    <section class="band band--white" aria-labelledby="training-title">
      <div class="container">
        <h2 id="training-title">Formations</h2>
        <training-component/>
      </div>
    </section>

    <advices-component/>
    <call-to-action-component variant="services"/>
  </div>
</template>

<script>
  import site from "@/content/site";
  import pages from "@/content/pages";
  import {inline} from "@/seo/inline";
  import {useSeo} from "@/seo/useSeo";
  import {organization, person, webPage, breadcrumb, absoluteUrl} from "@/seo/schema";
  import BannerComponent from "@/components/BannerComponent.vue";
  import ExperiencesComponent from "@/components/ExperiencesComponent.vue";
  import TrainingComponent from "@/components/TrainingComponent.vue";
  import AdvicesComponent from "@/components/AdvicesComponent.vue";
  import CallToActionComponent from "@/components/CallToActionComponent.vue";

  const PATH = '/portfolio';

  const BREADCRUMBS = [
    {name: 'Accueil', path: '/'},
    {name: 'À propos', path: PATH}
  ];

  export default {
    name: 'PortfolioView',
    components: {BannerComponent, ExperiencesComponent, TrainingComponent, AdvicesComponent, CallToActionComponent},
    setup() {
      const page = pages.find(entry => entry.path === PATH);
      const author = person();
      useSeo({
        path: PATH,
        image: '/img/og/portfolio.jpg',
        graph: [
          organization(),
          {
            ...author,
            description: 'Développeur full stack, fondateur de Citron Digital et créateur du Gestionnaire Citron.',
            knowsAbout: ['Développement web', 'Vue.js', 'Node.js', 'Applications SaaS', 'Facturation électronique', 'Référencement naturel']
          },
          webPage(PATH, page.title, page.description, {
            '@type': 'ProfilePage',
            mainEntity: {'@id': author['@id']},
            breadcrumb: {'@id': `${absoluteUrl(PATH)}#breadcrumb`}
          }),
          {...breadcrumb(BREADCRUMBS), '@id': `${absoluteUrl(PATH)}#breadcrumb`}
        ]
      });
    },
    data: function () {
      return {
        site,
        breadcrumbs: BREADCRUMBS,
        lead: inline('Micro-entrepreneur à Toulouse depuis juillet 2020, je conçois des **sites et des applications web** sous l\'enseigne Citron Digital. Je suis aussi l\'auteur du [Gestionnaire Citron](/gestionnaire-citron), un logiciel de devis et de factures. Voici mon parcours.'),
      }
    }
  }
</script>
